import React, { useState } from 'react'
import { Formik } from 'formik'
import { Button, ModalComponent, TextFieldIcon, SelectFieldIcon, FileFieldIcon } from '../../_components'
import { Stepper, Step, StepLabel, CircularProgress } from '@material-ui/core'
import Axios from 'axios'
import { FaUserAlt, FaIdCardAlt } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux'
import { setDisplayModal, setEducationList, setEmployeeList } from '../../_slices/AppSlice'
import { handleFileChange } from '../../_utils'

// import Init from './Init'
import SectionA from './SectionA'
import SectionB from './SectionB'
import SectionC from './SectionC'
import PreviewForm from './PreviewForm'

const steps = [
    "Section A",
    "Section B",
    "Section C",
    "Preview Application"
]

const renderContent = ( step, handleChange, handleBlur, values, signing, EducationFiles, setEducationFiles ) => {
    switch( step ) {
        case 0:
            return <SectionA 
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values} 
                    signing={signing}
                    EducationFiles={EducationFiles}
                    setEducationFiles={setEducationFiles}
                />
        case 1:
            return <SectionB
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values} 
                    signing={signing}/>
        case 2: 
            return <SectionC 
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values} 
                    signing={signing} />
        case 3:
            return <PreviewForm 
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    values={values} 
                    signing={signing} />
        default:
            break;
    }
}

export default function() {
    const dispatch = useDispatch()
    const state = useSelector( state => {
        return {
            flag: state.application.displayModal?.flag,
            title: state.application.displayModal?.title,
            educationList: state.application.educationList,
            employeeList: state.application.employeeList,
            experienceProofFiles: state.application.experienceProofFiles,
            locationProofFiles: state.application.locationProofFiles,
            sectionAData: state.application.sectionAData
        }
    })
    const [ signing, setSigning ] = React.useState( false )
    const [ activeStep, setActiveStep ] = React.useState( localStorage.getItem( "cachedStep" ) ?? 0 )
    const isLastStep = activeStep === ( steps.length - 1 )
    const [ EducationFiles, setEducationFiles ] = React.useState( [] )
    const [ fileList, setFiles ] = useState( {} )
    const [ userAttestation, setUserAttestition] = useState(false)
    const [ editFormValues, setEditFormValues] = useState(null)
    const [ loadingApp, setLoadingApp ] = React.useState( true )
    const [ saveForLaterState, setSaveForLaterState ] = useState( false )

    React.useEffect( () => {
        if( localStorage.getItem( "edit_set" ) == "true" ) {
            fetchApplication()
        }
    },[ loadingApp ])
    
    const saveFile = async ( id ) => {
        const data = new FormData()

        if( EducationFiles.length > 0 ) {
            for( var count = 0; count < EducationFiles.length; count++ ) {
                let item = EducationFiles[ count ]
                let key = Object.keys( item )
                let val = Object.values( item )
        
                data.append( "files[]", val[ 0 ] )
                data.append( "name", val[0]?.name )
                data.append( "size", val[0]?.size )
                data.append( "reference_id", id )
                data.append( "slug", "certification" )
            }
        
            try {
                const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/staffFiles`, data, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                } )
            } catch (error) {
                // console.log( error )
            }
        }
    }

    const handleButtonClick = async (event) => {
        let id = event.currentTarget.id
        if (id === "saveForLater1" || id === "saveForLater2") {
            setSaveForLaterState(true)
        }
    }

    const handleSubmit = async ( values ) => {
        let documents = state.educationList.filter( item => item.qualification !== "").map( item => {
            return { 
                title: item.title, 
                size: item.size, 
                details: item.details, 
                description: "education",
                userid: item.userid, 
                id: item.id, 
                file: item.file, 
                type: item.type,
                created_by: localStorage.getItem( "username" ), 
            }
        } )

        let employee_documents = state.employeeList.filter( item => item.qualification !== "").map( item => {
            return { 
                title: item.title, 
                size: item.size, 
                details: item.details, 
                description: "education",
                userid: item.userid, 
                id: item.id, 
                file: item.file, 
                type: item.type,
                created_by: localStorage.getItem( "username" ), 
            }
        } )

        let applicant_experience_docs = state.experienceProofFiles.filter( item => item.title !== "").map( item => {
            return { 
                title: item.title, 
                size: item.size,  
                details: item.size, 
                description: item.tag, 
                file: item.file, 
                type: item.type,
                created_by: localStorage.getItem( "username" ), 
            }
        } )

        let applicant_location_docs = state.locationProofFiles.filter( item => item.title !== "").map( item => {
            return { 
                title: item.title, 
                size: item.size,  
                details: item.size, 
                description: "location_proof", 
                file: item.file, 
                type: item.type,
                created_by: localStorage.getItem( "username" ), 
            }
        } )

        if( isLastStep ) {
        
            try {
                const params = {
                    category: values.category,
                    gender: values.gender,
                    given_name: values.given_name,
                    middle_name: values.middle_name,
                    surname: values.surname,
                    nationality: values.nationality,
                    passport_number: values.passport_number,
                    national_id: values.national_id,
                    tin: values.tin,
                    annual_turnover: values.annual_turnover,
                    application_purpose: values.application_purpose,
                    certification_level: values.certification_level,
                    company_certification: values.company_certification,
                    contact_first_name: values.contact_first_name,
                    contact_last_name: values.contact_last_name,
                    contact_middle_name: values.contact_middle_name,
                    contact_phone_number: state.sectionAData.contact_phone_number,
                    second_contact_first_name: values.second_contact_first_name,
                    second_contact_last_name: values.second_contact_last_name,
                    second_contact_middle_name: values.second_contact_middle_name,
                    second_contact_phone_number: state.sectionAData.secondary_contact_phone_number,
                    //itsp_level_applied_for: values.itsp_level_applied_for,
                    iso_number: values.iso_number,
                    district: values.district,
                    county: values.county,
                    subcounty: values.subcounty,
                    village: values.village,
                    parish: values.parish,
                    physical_address: values.physical_address,
                    doc: values.doc,
                    entity_name: state.sectionAData.entity_name,
                    entity_registration: values.entity_registration,
                    entity_type: values.entity_type,
                    ern: values.ern,
                    experience: values.experience,
                    no_females: values.no_females,
                    no_males: values.no_males,
                    service_type: values.service_type,
                    trading_name: values.trading_name,
                    validity: values.validity,
                    website: values.website,
                    location_proof: values.location_proof,
                    membership: values.membership,
                    created_by: localStorage.getItem( "email" ),
                    education_items: state.educationList.filter( item => item.qualification !== ""),
                    employee_items: state.employeeList.filter( item => item.qualification !== ""),
                    documents: documents,
                    employee_documents: employee_documents,
                    service_name: values.category === "Company" ? state.sectionAData.serviceName : state.sectionAData.skillName,
                    applicant_experience_docs: applicant_experience_docs,
                    applicant_location_docs: applicant_location_docs,
                    stage: 1,
                    progress: 0,
                    tax_payer_name: state.sectionAData.taxPayerName,
                    application_id: (localStorage.getItem( "edit_set" ) === "true") ? localStorage.getItem( "applicationId" ) : null
                }


                // console.log("below are the params")
                // console.log(params)
                // return;


                await setSigning( true )
                const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication`, params )
                if( response.data ) {
                    // await saveFile( response.data.id )
                    console.log(response.data.message)
                    alert( response.data.message )
                    await setSigning( false )
                    console.log(response.data.details)
                    if (response.data.id !== 0) {
                        // if not a duplicate go ahead and reload
                        localStorage.removeItem("edit_set")
                        window.location.reload()                        
                    }
                }
            } catch (error) {
                console.log(error)
                alert( error )
                await setSigning( false )
            }
        } 
        else {
            setActiveStep( activeStep + 1 )

            if (saveForLaterState) {
                console.log("if save for later is clicked, save but do not reload")
                try {
                    const params = {
                        category: values.category,
                        gender: values.gender,
                        given_name: values.given_name,
                        middle_name: values.middle_name,
                        surname: values.surname,
                        nationality: values.nationality,
                        passport_number: values.passport_number,
                        national_id: values.national_id,
                        tin: values.tin,
                        annual_turnover: values.annual_turnover,
                        application_purpose: values.application_purpose,
                        certification_level: values.certification_level,
                        company_certification: values.company_certification,
                        contact_first_name: values.contact_first_name,
                        contact_last_name: values.contact_last_name,
                        contact_middle_name: values.contact_middle_name,
                        contact_phone_number: state.sectionAData.contact_phone_number,
                        second_contact_first_name: values.second_contact_first_name,
                        second_contact_last_name: values.second_contact_last_name,
                        second_contact_middle_name: values.second_contact_middle_name,
                        second_contact_phone_number: state.sectionAData.secondary_contact_phone_number,
                        //itsp_level_applied_for: values.itsp_level_applied_for,
                        iso_number: values.iso_number,
                        district: values.district,
                        county: values.county,
                        subcounty: values.subcounty,
                        village: values.village,
                        parish: values.parish,
                        physical_address: values.physical_address,
                        doc: values.doc,
                        entity_name: state.sectionAData.entity_name,
                        entity_registration: values.entity_registration,
                        entity_type: values.entity_type,
                        ern: values.ern,
                        experience: values.experience,
                        no_females: values.no_females,
                        no_males: values.no_males,
                        service_type: values.service_type,
                        trading_name: values.trading_name,
                        validity: values.validity,
                        website: values.website,
                        location_proof: values.location_proof,
                        membership: values.membership,
                        created_by: localStorage.getItem( "email" ),
                        education_items: state.educationList.filter( item => item.qualification !== ""),
                        employee_items: state.employeeList.filter( item => item.qualification !== ""),
                        documents: documents,
                        employee_documents: employee_documents,
                        service_name: values.category === "Company" ? state.sectionAData.serviceName : state.sectionAData.skillName,
                        applicant_experience_docs: applicant_experience_docs,
                        applicant_location_docs: applicant_location_docs,
                        stage: 1,
                        progress: 0,
                        tax_payer_name: state.sectionAData.taxPayerName,
                        application_id: localStorage.getItem( "applicationId" ) ?? null
                    }


                    // console.log("below are the params")
                    // console.log(params)
                    // return;


                    //await setSigning( true )
                    const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication`, params )
                    if( response.data ) {
                        // await saveFile( response.data.id )
                        console.log(response.data.message)
                        alert( response.data.message )
                        //await setSigning( false )
                        console.log(response.data.details)
                        if (response.data.id !== 0) {
                            // if not a duplicate go ahead and reload
                            localStorage.setItem( "applicationId", response.data.id )                   
                        }
                    }
                } catch (error) {
                    console.log(error)
                    alert( "System failed to save for later." )
                    await setSigning( false )
                }
            }



        }
    }

    const handleBack = () => setActiveStep( activeStep - 1 )

    const handleSubmitForm = async values => {
        let savedFile = { 
            file: fileList.document, 
            title: fileList.name, 
            size: fileList.size, 
            type: fileList.type, 
            details: "itco",
            userid: localStorage.getItem( "userId" ),
            id: 10

        }

        let data = Object.assign( values, savedFile )
        if( state.title?.toLowerCase() === "education" ) {
            await dispatch(  setEducationList( { educationList: [ ...state.educationList, data ] } ) )
        }
        
        if( state.title?.toLowerCase() === "employees" ) {
            await dispatch( setEmployeeList( { employeeList: [ ...state.employeeList, fileList, data ] } ) )
        }
        // send to server
        // handleUploadFiles( data )
        // close the modal
        await dispatch( setDisplayModal( { flag: false, title: "" } ) )
    }

    const handleFile = ( evt, tag ) => {
        handleFileChange( evt, tag, (response, file ) => {
            if(file.size > 2128180){
                alert("Please make sure that the file size doesn't exceed 2 MBs")
            } else{
                setFiles( {
                    document: response,
                    name: file.name,
                    size: file.size,
                    tag,
                    type: file.type
                } )
            }
        } )

    }

    const handleUploadFiles = async ( id ) => {
        let documents = state.educationList.map( item => {
            return { 
                title: item.title, 
                size: item.size, 
                details: item.details, 
                userid: id, 
                id: id, 
                file: item.file, 
                type: item.type,
                created_by: localStorage.getItem( "username" ),
            }
        } )
        // console.log( "documents", documents );
        // let payload = [ { 
        //     title: data.title, 
        //     size: data.size, 
        //     details: data.details, 
        //     userid: data.userid, 
        //     id: data.id,
        //     file: data.file,
        //     type: data.type
        // } ]

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/addITDocuments`, {
                documents
            } )
            if( response.data ) {
                //console.log( "we are here",response.data );
            }
        } catch (error) {
            console.log( error );
        }
    }

    const toggleAttestationCheckbox = (evt) => {
        setUserAttestition(!userAttestation)
    }

    const handleBackButton = async () => {
        setActiveStep( activeStep - 1 )
        //await setSigning( true )
        //window.location.reload()
    }

    const handleApplicationReview = () => {
        //console.log('application review')
        setActiveStep(0)
    }

    const initialFormValues = {
        application_id: null,
        category: state.sectionAData.applicantCategory,
        nationality: "Ugandan",
        national_id: state.sectionAData.nin,
        passport_number: state.sectionAData.passport_number,
        surname: state.sectionAData.surname,
        middle_name: state.sectionAData.middleName,
        given_name: state.sectionAData.firstName,
        tin: state.sectionAData.tin,
        cert_completion_year_1: "",
        cert_institution_1: "",
        proof_experience: null,

        entity_registration: state.sectionAData.entity_registration,
        ern: state.sectionAData.brn,
        entity_name: state.sectionAData.entity_name,
        doc: state.sectionAData.dateOfIncorporation,
        entity_type: state.sectionAData.entityType,
        contact_first_name: state.sectionAData.contact_first_name,
        contact_last_name: state.sectionAData.contact_last_name,
        contact_middle_name: state.sectionAData.contact_middle_name,
        contact_phone_number: state.sectionAData.contact_phone_number,
        application_purpose: state.sectionAData.applicationPurpose,
        validity: state.sectionAData.validity,
        experience: state.sectionAData.experience,
        trading_name: state.sectionAData.trading_name,

        second_contact_first_name: null,
        second_contact_last_name: null,
        second_contact_middle_name: null,
        second_contact_phone_number: state.sectionAData.secondary_contact_phone_number,
        //itsp_level_applied_for: null,
        iso_number: null,

        district: state.sectionAData.district,
        county: state.sectionAData.county,
        subcounty: state.sectionAData.subcounty,
        parish: state.sectionAData.parish,
        village: state.sectionAData.village,
        location_proof: state.sectionAData.location_proof,
        service_type: state.sectionAData.service_type,
        specify_service: state.sectionAData.specify_service,
        website: state.sectionAData.website,
        annual_turnover: state.sectionAData.annual_turnover,
        company_certification: state.sectionAData.company_certification,
        membership: state.sectionAData.membership,
        specify_membership: state.sectionAData.specify_membership,
        no_males: state.sectionAData.no_males,
        no_females: state.sectionAData.no_females,
        certification_level: state.sectionAData.certification_level,
    }

    const fetchApplication = async () => {
        try {
            const response =  await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/${localStorage.getItem( "applicationId" )}` )
            if( response.data ) {
                const dbValues = {
                    category: response.data.record.category,
                    nationality: response.data.record.nationality,
                    national_id: response.data.record.national_id,
                    passport_number: response.data.record.passport_number,
                    surname: response.data.record.surname,
                    middle_name: response.data.record.middle_name,
                    given_name: response.data.record.given_name,
                    tin: response.data.record.tin,
                    proof_experience: null,            
                    entity_registration: response.data.record.entity_registration,
                    ern: response.data.record.ern,
                    entity_name: response.data.record.entity_name,
                    doc: response.data.record.doc,
                    entity_type: response.data.record.entity_type,
                    contact_first_name: response.data.record.contact_first_name,
                    contact_last_name: response.data.record.contact_last_name,
                    contact_middle_name: response.data.record.contact_middle_name,
                    contact_phone_number: response.data.record.contact_phone_number,
                    trading_name: response.data.record.trading_name,
                    application_purpose: response.data.record.application_purpose,
                    experience: response.data.record.experience,

                    second_contact_first_name: response.data.record.second_contact_first_name,
                    second_contact_last_name: response.data.record.second_contact_last_name,
                    second_contact_middle_name: response.data.record.second_contact_middle_name,
                    second_contact_phone_number: response.data.record.second_contact_phone_number,
                    //itsp_level_applied_for: response.data.record.itsp_level_applied_for,
                    iso_number: response.data.record.iso_number,

                    service_name: response.data.record.service_name,
                    district: response.data.record.district,
                    county: response.data.record.county,
                    subcounty: response.data.record.subcounty,
                    parish: response.data.record.parish,
                    village: response.data.record.village,
                    website: response.data.record.website,
                    no_males: response.data.record.no_males,
                    no_females: response.data.record.no_females,
                    location_proof: response.data.record.location_proof,
                    service_type: response.data.record.service_type,
                    specify_service: response.data.record.specify_service,
                    annual_turnover: response.data.record.annual_turnover,
                    company_certification: response.data.record.company_certification,
                    membership: response.data.record.membership,
                    specify_membership: response.data.record.specify_membership,
                    certification_level: response.data.record.certification_level,
                }
                setEditFormValues(dbValues);
                setLoadingApp( false )
                console.log("=======")
                console.log(dbValues)
            }
        } catch (error) {
        }
    }

    return (
        <div>
        <Stepper activeStep={activeStep}>
            {steps.map( label => {
                return (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                )
            } )}
        </Stepper>
        {(localStorage.getItem( "edit_set" ) === "true") ? ( 
            <Formik initialValues={editFormValues || initialFormValues} onSubmit={handleSubmit} enableReinitialize>

            { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                    return (
                        <form id="mainForm" className="my-2 bg-white" onSubmit={handleSubmit}>
                            {renderContent( activeStep, handleChange, handleBlur, values, signing, EducationFiles, setEducationFiles )}
                            <input type="hidden" value={editFormValues ? localStorage.getItem( "applicationId" ) : null } name="application_id" />
                            <div className="w-full py-2 grid grid-cols-1">
                                {signing ? (
                                    <div className="flex items-center justify-center">
                                        <CircularProgress size={24} color="primary" />
                                    </div>
                                ):
                                ( <div>                            
    
                                    {isLastStep && <div><input type="checkbox" name="attestation" value="yes" onClick={toggleAttestationCheckbox} /> I certify that the information provided in this application is true and authentic. I am aware that failure to provide accurate information may result into delayed processing or rejection of my application or prosecution in Courts of Law or any other punitive measure for giving misleading information<br/><br/></div>}
    
                                    {(activeStep !== 0) && <button className="bg-blue-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={handleBackButton} >Back</button>}

                                    {<button className="bg-blue-300 px-2 py-1 mx-2 text-sm text-white rounded-sm" id="saveForLater1" onClick={handleButtonClick}  type="submit"
                                        loading={isSubmitting}>Save for Later</button>}
    
                                    {/* {isLastStep && <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" name="completion_status" value="incomplete" onClick={handleSubmit} >Save Application</button>} */}
    
                                    {/* {isLastStep && <button className="bg-blue-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={evt => {
                                        handleApplicationReview( evt)
                                    }} >Preview</button>} */}
    
                                    {((isLastStep && userAttestation === false)) ? '' : <Button 
                                    type="submit"
                                    loading={isSubmitting} 
                                    disabled={isSubmitting ? true : false} 
                                    label={`${ isLastStep ? "Submit" : "Next" }`} />}
    
                                </div> )
                                }
                            </div>
                        </form>
                    )
                }  }
            </Formik>
            ): (
                <Formik initialValues={initialFormValues} onSubmit={handleSubmit}>

                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                        return (
                            <form id="mainForm" className="my-2 bg-white" onSubmit={handleSubmit}>
                                {renderContent( activeStep, handleChange, handleBlur, values, signing, EducationFiles, setEducationFiles )}
                                <input type="hidden" value={editFormValues ? localStorage.getItem( "applicationId" ) : null } name="application_id" />
                                <div className="w-full py-2 grid grid-cols-1">
                                    {signing ? (
                                        <div className="flex items-center justify-center">
                                            <CircularProgress size={24} color="primary" />
                                        </div>
                                    ):
                                    ( <div>                            
        
                                        {isLastStep && <div><input type="checkbox" name="attestation" value="yes" onClick={toggleAttestationCheckbox} /> I certify that the information provided in this application is true and authentic. I am aware that failure to provide accurate information may result into delayed processing or rejection of my application or prosecution in Courts of Law or any other punitive measure for giving misleading information<br/><br/></div>}
        
                                        {(activeStep !== 0) && <button className="bg-blue-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={handleBackButton} >Back</button>}

                                        {(state.sectionAData.applicantCategory !== "") && <button className="bg-blue-300 px-2 py-1 mx-2 text-sm text-white rounded-sm" id="saveForLater2" type="submit"
                                        loading={isSubmitting}>Save for Later</button>}
        
                                        {/* {isLastStep && <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" name="completion_status" value="incomplete" onClick={handleSubmit} >Save Application</button>} */}
        
                                        {/* {isLastStep && <button className="bg-blue-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={evt => {
                                            handleApplicationReview( evt)
                                        }} >Preview</button>} */}
        
                                        {((isLastStep && userAttestation === false) || state.sectionAData.tinVerificationStatus === false) ? '' : <Button 
                                        type="submit"
                                        loading={isSubmitting} 
                                        disabled={isSubmitting ? true : false} 
                                        label={`${ isLastStep ? "Submit" : "Next" }`} />}
        
                                    </div> )
                                    }
                                </div>
                            </form>
                        )
                    }  }
                </Formik>
                )
            }

        
            <ModalComponent title={state.title} open={state.flag} handleOpen={() => dispatch( setDisplayModal( { flag: false, title: "" } ) )}>
                <Formik
                    initialValues={{
                        employee_firstname: "",
                        employee_lastname: "",
                        employee_middle_name: "",
                        qualification: "",
                        year_completion: "",
                        institution: "",
                        degree_type: "",
                        attachment: ""
                    }}
                    onSubmit={() => {}}>
                    { ( { handleChange, values, errors } ) => {
                        return (
                            <form>
                                <button onClick={() => dispatch( setDisplayModal( { flag: false, title: "" } ) )}>Close</button>
                                {state.title?.toLowerCase() === "employees" && (
                                    <div className="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-3 my-3 mb-2">
                                        <TextFieldIcon
                                            type="text"
                                            name="employee_firstname"
                                            value={values?.employee_firstname}
                                            handleChange={handleChange}
                                            iconComponent={<FaUserAlt color={`#666`} />}
                                            label="First Name( Employee )"
                                            question="First Name( Employee )" 
                                            required={state.title?.toLowerCase() === "employees" && true} 
                                        />

                                        <TextFieldIcon
                                            type="text"
                                            name="employee_lastname"
                                            value={values?.employee_lastname}
                                            handleChange={handleChange}
                                            iconComponent={<FaUserAlt color={`#666`} />}
                                            label="Last Name( Employee )"
                                            question="Last Name( Employee )" 
                                            required={state.title?.toLowerCase() === "employees" && true} 
                                        />

                                        <TextFieldIcon
                                            name="employee_middle_name"
                                            value={values?.employee_middle_name}
                                            handleChange={handleChange}
                                            iconComponent={<FaUserAlt color={`#666`} />}
                                            label="Middle Name( Employee )"
                                            question="Middle Name( Employee )" 
                                            required={state.title?.toLowerCase() === "employees" && false} 
                                        />
                                    </div>
                                )}

                                { ( ( state.title?.toLowerCase() === "education" ) || ( state.title?.toLowerCase() === "employees" ) ) && 
                                ( 
                                <div className="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-3 my-3 mb-10">
                                    <SelectFieldIcon
                                        name="qualification"
                                        handleChange={handleChange}
                                        value={values?.qualification}
                                        iconComponent={<FaIdCardAlt color="#666"/>}
                                        label="Qualification"
                                        defaultOption="Choose Your Gender"
                                        question="Qualification"
                                        required={true} 
                                        options={[
                                        { id: 1, value: "Certificate", label: "Certificate" },
                                        { id: 2, value: "Diploma", label: "Diploma" },
                                        { id: 3, value: "Degree", label: "Degree" },
                                        { id: 4, value: "Masters", label: "Master's Degree" },
                                        { id: 5, value: "PGD", label: "Post Graduate Degree" },
                                        { id: 6, value: "Other", label: "Specify Other" }
                                    ]} />

                                {values?.qualification === "Other" && 
                                ( <TextFieldIcon
                                    name="specify_qualification"
                                    value={values?.specify_qualification}
                                    handleChange={handleChange}
                                    iconComponent={<FaUserAlt color={`#666`} />}
                                    label="Specify other qualification"
                                    question="Specify other qualification" 
                                    required={values?.qualification === "Other" && true} 
                                /> ) }

                                <TextFieldIcon
                                    type="date"
                                    name="year_completion"
                                    value={values?.year_completion}
                                    handleChange={handleChange}
                                    iconComponent={<FaUserAlt color={`#666`} />}
                                    label="Year( Year of Completion )"
                                    question="Year( Year of Completion )" 
                                    required={true} 
                                />

                                <TextFieldIcon
                                    name="institution"
                                    value={values?.institution}
                                    handleChange={handleChange}
                                    iconComponent={<FaUserAlt color={`#666`} />}
                                    label="Issuing Institution"
                                    question="Issuing Institution" 
                                    required={true} 
                                />

                                <TextFieldIcon
                                    name="degree_type"
                                    value={values?.degree_type}
                                    handleChange={handleChange}
                                    iconComponent={<FaUserAlt color={`#666`} />}
                                    label="Type of Degree"
                                    question="Type of Degree/Field of Study( Where Applicable )" 
                                    required={false} 
                                />

                                <FileFieldIcon
                                    noPadding
                                    name="attachment"
                                    value={values?.attachment}
                                    handleChange={evt => {
                                        handleChange(evt)
                                        handleFile( evt, "education" )
                                    }}
                                    iconComponent={<FaUserAlt color={`#666`} />}
                                    label="Attachment"
                                    question="Attachment (Max size: 5MB)" 
                                    required={false} 
                                />
                                </div> 
                                ) }

                                <div className="self-end flex items-center my-2">
                                    <button className="bg-blue-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={() => dispatch( setDisplayModal( { flag: false, title: "" } ) )}>
                                        {`Cancel`}
                                    </button>
                                    <button className="bg-green-700 px-3 py-1 mx-2 text-sm text-white rounded-sm" type="button" onClick={() => handleSubmitForm( values, errors )}>
                                        {`Save`}
                                    </button>
                                </div>
                            </form>
                        )
                    } }
                </Formik>
            </ModalComponent>
        </div>
    )
}
